import en from './en.json';
import sv from './sv.json';

type Messages = Record<string, string>;

/**
 * Each locale backfills the keys the other is missing, so a message added to
 * only one file never renders as a raw id in the other.
 *
 * The merge has to go through `Messages`: `resolveJsonModule` types each import
 * as an exact object literal, which cannot be indexed by an arbitrary string.
 */
const backfillMissingKeys = (target: Messages, source: Messages) => {
  Object.keys(source).forEach((key) => {
    if (source[key] && !target[key]) {
      target[key] = source[key];
    }
  });
};

backfillMissingKeys(sv, en);
backfillMissingKeys(en, sv);

export const locales = {
  en,
  sv,
};
